import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Quick as Tooltip } from './Tooltip';
export function DisabledWithTooltip({ isDisabled, position, reason, children, tooltipWidth = 200, }) {
    if (!isDisabled)
        return _jsx(_Fragment, { children: children });
    return (_jsx(Tooltip, { cursor: isDisabled ? 'default' : 'pointer', content: reason, maxWidth: tooltipWidth, side: position, children: children }));
}
